export enum FilterOptionsEnum {
    SAMPLE,
    PRIMER,
}
